<template>
  <div>
    <ChooseAmount :initial_value="amount" />
    <div class="full-width column">
      <TypePayment :initial_value="payment" />
      <TypeCustomer :initial_value="customer" />
    </div>
    <div class="full-width">
      <DonateInfo />
    </div>
  </div>
</template>

<script>
import ChooseAmount from "@/components/ChooseAmount.vue"
import TypePayment from "@/components/TypePayment.vue"
import TypeCustomer from "@/components/TypeCustomer.vue"

import DonateInfo from "@/components/DonateInfo.vue"

export default {
  components: {
    ChooseAmount,
    TypePayment,
    TypeCustomer,

    DonateInfo,
  },
  props: [],
  data: () => {
    return {}
  },

  created() {
    this.$store.state.page.index = 1
  },

  methods: {},
  computed: {
    payment: function () {
      return this.$store.state.payment_info.type_payment
    },
    customer: function () {
      return this.$store.state.user_info.type_customer
    },
    amount: function () {
      return this.$store.state.payment_info.amount
    },
  },
}
</script>
